import BurgerMenu from "../../assets/Icons/BurgerMenu";
import { RiArrowDropDownLine } from "react-icons/ri";
import { handleLogout, api } from "../../api";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalSearch } from "../GlobalSearch/GlobalSearch";
import { SearchResult } from "../../services/searchService";

interface SideBarPropsTopBar {
  setIsSideBarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const TopBar = ({ setIsSideBarOpen }: SideBarPropsTopBar) => {
  const navigate = useNavigate();

  const handleSideBar = () => {
    setIsSideBarOpen((prev) => !prev);
  };

  const [dropDownClicked, setDropDownClicked] = useState<boolean>(false);
  const [userData, setUserData] = useState<any>({});

  // api to get logged in user data
  useEffect(() => {
    api.get("/users/me").then((response: any) => {
      setUserData(response?.data);
    });
  }, []);

  const handleSearchResultSelect = (result: SearchResult) => {
    // Navigate to project detail page based on source table
    const routeMap: Record<string, string> = {
      carbon_projects: "project",
      mangrove_recommendations: "recommendation/mangrove",
      forest_recommendations: "recommendation/forest",
    };

    const route = routeMap[result.source_table];
    if (route) {
      navigate(`/${route}/${result.id}`);
    }
  };

  const username = userData?.username || (userData?.email || "").split("@")[0];
  return (
    <div className="sticky top-0 z-10 mb-4 w-full bg-white px-6 shadow-sm">
      <div className="flex h-[70px] items-center justify-between gap-6">
        <div className="flex items-center gap-6">
          {/* menu icon */}
          <div className="flex-shrink-0 cursor-pointer" onClick={handleSideBar}>
            <BurgerMenu fill={"black"} className={"h-8 w-8"} />
          </div>

          {/* Global Search */}
          <div className="w-[600px]">
            <GlobalSearch onResultSelect={handleSearchResultSelect} />
          </div>
        </div>

        <div className="flex flex-shrink-0 items-center gap-6">
          <div className="flex items-center gap-3 text-base">
            {/* user photo */}
            {/* <div>
              <img src={User} alt="user image" className="w-8 rounded-full" />
            </div> */}
            <div>
              <p className="text-sm">{username}</p>
            </div>
            <div className="rounded-full bg-gray-100 p-1 text-black">
              <RiArrowDropDownLine
                className="cursor-pointer text-xl"
                onClick={() => setDropDownClicked(!dropDownClicked)}
              />
            </div>
          </div>
          {/* <div className="h-6 w-0.5 bg-gray-300"></div>
          <button onClick={handleLogout}>Log out</button> */}
          {dropDownClicked && (
            <div className="absolute right-4 top-16 rounded-md bg-purple-900 px-4 py-2 text-sm text-white shadow-md">
              <button onClick={handleLogout}>Log out</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
